import styled from "styled-components";

export const H3Font = styled.div`
  color: ${p => p.theme.colors.secondary};
  font-size: 0.9rem;
`;

export const H3 = styled(H3Font as any) <{
  marginTop?: string,
  marginRight?: string,
  marginBottom?: string,
  marginLeft?: string,
  textAlign?: string,
}>`
  display: block;
  margin-top: ${p => p.marginTop || ".25rem"};
  margin-right: ${p => p.marginRight || "0rem"};
  margin-bottom: ${p => p.marginBottom || ".25rem"};
  margin-left: ${p => p.marginLeft || "0rem"};
  text-align: ${p => p.textAlign || "left"};
  cursor: default;
`;
